module.exports = __webpack_public_path__ + "img/no-shop.f6f3674e.png";